import { Sweepstakes as SweepstakesComponent } from "@shared/components";
import { useUser } from "@shared/hooks/user";
import React from "react";

interface IProps {
  isSmall?: boolean;
  isColumn?: boolean;
}
export const Sweepstakes: React.FC<IProps> = ({ isColumn, isSmall }) => {
  const user = useUser();
  return (
    <SweepstakesComponent isSmall={isSmall} isColumn={isColumn} user={user} />
  );
};
